import React from "react"
import { Plus } from "@styled-icons/boxicons-regular"

import { Element } from "legacy/components/shared/base"
import { useTheme } from "src/legacy/utils"

interface OwnProps {
  open: boolean
  setOpen: (open: boolean) => void
}

export type NavigationTriggerProps = OwnProps

const NavigationTrigger: React.FC<NavigationTriggerProps> = ({
  open,
  setOpen,
}): React.ReactElement => {
  const { colors } = useTheme()
  const transform = `${open ? "rotate(225deg)" : "rotate(0)"}`

  return (
    <Element
      alignItems="center"
      cursor="pointer"
      display={["flex", "flex", "flex", "none"]}
      height={20}
      justifyContent="flex-end"
      justifySelf="flex-end"
      ml="auto"
      onClick={() => setOpen(!open)}
      width={20}
    >
      <Element style={{ transform }} transition="all 0.3s ease">
        <Plus color={colors.teal} width={20} height={20} />
      </Element>
    </Element>
  )
}

export default NavigationTrigger
